import {
  CalendarCheck,
  Clock,
  GraduationCap,
  Lightbulb,
  MapPin,
  MessageSquare,
} from "lucide-react";
import "./ccPartnership.css";

import launchShot from "../../../assets/two-weeks.webp";

/* What the partnership actually consists of once the two weeks are over.
   Short labels only — the sentence beside them does the explaining. */
const support = [
  { label: "Working sessions", Icon: CalendarCheck, tint: "var(--c-blue)" },
  { label: "Dedicated Slack channel", Icon: MessageSquare, tint: "var(--c-teal)" },
  { label: "Same-day answers", Icon: Clock, tint: "var(--c-coral)" },
  { label: "Refresher training", Icon: GraduationCap, tint: "var(--c-violet)" },
  { label: "Campus visits", Icon: MapPin, tint: "var(--c-blue-deep)" },
  { label: "Roadmap input", Icon: Lightbulb, tint: "var(--c-magenta)" },
];

const CcPartnership = () => (
  <section className="cc-section cc-partnership">
    <div className="home-container">
      {/* Copy beside a photograph. */}
      <div className="cc-launch">
        <div className="cc-launch-copy">
          <h2 className="cc-launch-title">Live in two weeks, not a semester</h2>

          <p className="cc-launch-body">
            Branding, templates, AI guardrails, and SSO are configured on our
            side. It takes one working session from your team, and we handle
            student marketing and run the info sessions at launch.
          </p>

          <a className="cc-ghost-btn" href="#book">
            Book a walkthrough
          </a>
        </div>

        <div className="cc-launch-media">
          <img width={1364} height={909} decoding="async"
            src={launchShot}
            alt="A launch call with the RAIN team, beside a setup checklist: branded platform, SSO and LMS integrations, student data import, training and launch support, live and ready"
            loading="lazy"
          />
        </div>
      </div>

      {/* The same shape, flipped: small cards beside the copy. */}
      <div className="cc-after">
        <ul className="cc-after-grid">
          {support.map(({ label, Icon, tint }) => (
            <li className="cc-after-card" key={label}>
              <Icon size={24} strokeWidth={1.8} color={tint} aria-hidden="true" />
              <span>{label}</span>
            </li>
          ))}
        </ul>

        <div className="cc-after-copy">
          <h2 className="cc-after-title">Priority support, year-round</h2>

          <p className="cc-after-body">
            The two weeks end; the partnership doesn&rsquo;t. We come to campus,
            run info sessions, and drive adoption with flyers, email
            templates, and assets, built alongside your team.
          </p>

          <p className="cc-after-body">
            And you get a dedicated Slack channel. Not a ticketing system, not a
            bot. Real people who answer in real time.
          </p>

          <a className="cc-ghost-btn" href="#book">
            Book a walkthrough
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default CcPartnership;
